import { createSelector } from 'reselect';

import { SITE_ROOT_FOLDER_ID_NORDSTROM, SITE_ROOT_FOLDER_NAMES } from 'lib/const';

import cwdDetailsSelector from './cwdDetails';

const DEFAULT = SITE_ROOT_FOLDER_ID_NORDSTROM;

const isSiteRootFolder = id => !!SITE_ROOT_FOLDER_NAMES[id];

// selects id of the current site root folder
// first checks current folder id and then breadcrumb
export default createSelector(cwdDetailsSelector, cwdDetails =>
  isSiteRootFolder(cwdDetails?.Id)
    ? cwdDetails.Id
    : cwdDetails?.Breadcrumb?.map(({ Id }) => Id)?.find(isSiteRootFolder) || DEFAULT
);
